import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusShellBody], campus-shell-body',
})
export class ShellBodyDirective {
  @HostBinding('class.ui-shell-body')
  shellBodyClass = true;
}
